import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import amaxLogo from "../../images/amaxLogoWhite.png";
import arrowNext from "../../images/arrowNext.svg";

const AthleteStep3 = () => {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [sport, setSport] = useState("Sport");
  const [customSport, setCustomSport] = useState("");
  const [training_preference, setTrainingPreference] = useState("");
  const [error, setError] = useState(null);

  const sportDropdownOptions = [
    "Track and Field",
    "Football",
    "Baseball",
    "Softball",
    "Soccer",
    "Other",
  ];

  const handleOptionClick = (option) => {
    setSport(option);
    setIsOpen(false);
    if (option !== "Other") setCustomSport("");
  };

  useEffect(() => {
    // Restore data from sessionStorage
    const savedSport = sessionStorage.getItem("sport");
    const savedTrainingPref = sessionStorage.getItem("training_preference");

    if (savedTrainingPref) setTrainingPreference(savedTrainingPref);

    if (savedSport) {
      // If saved sport is not one of the predefined options → treat as "Other"
      if (!sportDropdownOptions.includes(savedSport)) {
        setSport("Other");
        setCustomSport(savedSport);
      } else {
        setSport(savedSport);
      }
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const isOther = sport === "Other";
    const trimmedCustom = customSport.trim();
    const finalSport = isOther ? "Other" : sport;
  
    if (
      !training_preference ||
      (!isOther && (sport === "Sport" || !sport)) ||
      (isOther && !trimmedCustom)
    ) {
      setError("Please enter all the details!");
      return;
    }
  
    setError(null);
  
    // ✅ Save correctly for backend
    sessionStorage.setItem("sport", finalSport);
    if (isOther) {
      sessionStorage.setItem("otherSportValue", trimmedCustom);
    } else {
      sessionStorage.removeItem("otherSportValue");
    }
  
    sessionStorage.setItem("training_preference", training_preference);
  
    navigate("/athlete/register/step4");
  };
  

  return (
    <div className="p-[20px] bg-white h-dvh overflow-hidden">
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
        <Link to="/" className="size-[96px] lg:size-[166px]">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>

        <div className="flex flex-col gap-12 w-full">
          <div className="flex flex-col justify-center gap-4">
            <h1 className="text-black text-3xl xs:text-4xl leading-tight font-light uppercase">
              training
              <br />
              <span className="text-4xl xs:text-5xl leading-tight font-bold">preference</span>
            </h1>

            <form onSubmit={handleSubmit} className="flex flex-col gap-4 relative">
              {/* Training preference radio buttons */}
              <div className="flex gap-[30px] w-full max-w-[315px] mx-auto justify-center py-6">
                <label className="flex items-center flex-col cursor-pointer">
                  <input
                    type="radio"
                    name="training"
                    value="on-site"
                    checked={training_preference === "on-site"}
                    onChange={() => setTrainingPreference("on-site")}
                    className="hidden"
                  />
                  <span
                    className={`w-[50px] h-[50px] rounded-full ${
                      training_preference === "on-site" ? "bg-black" : "bg-black/20"
                    }`}
                  ></span>
                  <span className="text-black font-normal mt-4 text-sm">ON-SITE TRAINING</span>
                </label>

                <label className="flex items-center flex-col cursor-pointer">
                  <input
                    type="radio"
                    name="training"
                    value="online"
                    checked={training_preference === "online"}
                    onChange={() => setTrainingPreference("online")}
                    className="hidden"
                  />
                  <span
                    className={`w-[50px] h-[50px] rounded-full ${
                      training_preference === "online" ? "bg-black" : "bg-black/20"
                    }`}
                  ></span>
                  <span className="text-black font-normal mt-4 text-sm">REMOTE TRAINING</span>
                </label>
              </div>

              {/* Sport Dropdown */}
              <div className="relative">
                <div
                  onClick={() => setIsOpen(!isOpen)}
                  className="bg-transparent text-black text-lg font-normal border border-black rounded-[45px] p-4 flex items-center justify-between cursor-pointer"
                >
                  {sport}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`transform transition-transform ${
                      isOpen ? "rotate-180" : "rotate-0"
                    }`}
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                  >
                    <path
                      d="M1 0.999999L7 7L13 1"
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                {isOpen && (
                  <div className="absolute bg-black border border-white rounded-md mt-2 w-full z-50 max-h-[250px] overflow-y-auto">
                    {sportDropdownOptions.map((option) => (
                      <div
                        key={option}
                        onClick={() => handleOptionClick(option)}
                        className="px-4 py-2 cursor-pointer text-lg font-normal text-white hover:bg-white/50"
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Custom sport input (visible only if "Other" selected) */}
              {sport === "Other" && (
                <input
                  type="text"
                  value={customSport}
                  onChange={(e) => setCustomSport(e.target.value)}
                  placeholder="Enter your sport"
                  className="mt-3 w-full border border-white rounded-[45px] p-4 bg-transparent text-white placeholder-white text-lg font-normal"
                />
              )}

              {/* Error message */}
              {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

              <button
                type="submit"
                className="bg-black size-12 xs:size-14 rounded-full flex justify-center items-center hover:bg-black/70 transition-all duration-300 ml-auto mt-[10px]"
              >
                <img src={arrowNext} alt="arrow" className="object-contain invert max-w-5 xs:max-w-6" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AthleteStep3;
